<script setup lang="ts">
import { computed } from 'vue';
import ThemePreview from '@/components/theme/edit/theme-preview.vue';
import { DocType } from '@/types';
import { getAllSiteCategories } from '@/utils/siteCategories';
import { useTeamInfo } from '@/utils/swr';

export interface Props {
  keywords: Array<string>;
}
defineProps<Props>();

const { data: teamInfo } = useTeamInfo();
const isForeignFeedAvailable = computed(
  () => teamInfo.value?.enable_foreign_lang_media,
);
const isTechnicalResearchAvailable = computed(
  () => teamInfo.value?.enable_technical_literature ?? false,
);
const docTypes = computed(
  () =>
    ['article'].concat(
      isTechnicalResearchAvailable.value ? ['research_paper', 'patent'] : [],
    ) as DocType[],
);
const allSiteCategories = getAllSiteCategories();
</script>

<template>
  <div class="preview">
    <ThemePreview
      class="o-theme-preview"
      :keywords="keywords"
      :is-foreign-feed-available="isForeignFeedAvailable"
      :is-foreign-media-enabled="isForeignFeedAvailable"
      :doc-types="docTypes"
      :is-technical-literature-available="isTechnicalResearchAvailable"
      :is-entertainment-filter-enabled="true"
      :site-categories="allSiteCategories"
      :is-alliance-media-enabled="true"
    />
  </div>
</template>

<style lang="scss" scoped>
.preview {
  flex: 1;
  max-height: 100%;
  min-width: 0;
}
.o-theme-preview {
  position: sticky;
  top: 0;
  // dialogのheight - dialogのヘッダーのheight - dialogの#descriptionのpadding-top - dialog下部との余白
  height: calc(95vh - 47px - 16px - 16px);
  width: auto;
  border: none;
  border-radius: 4px;
  border: 1px solid $color-gray400;
}
</style>
